"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GreaterThanFilterFn = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
const GreaterThanFilterFn = (rows, id, filterValue) => rows.filter(row => {
  const rowValue = row.values[id];
  if (typeof rowValue !== 'number' || typeof filterValue !== 'number') {
    return true;
  }
  return rowValue >= filterValue;
});
exports.GreaterThanFilterFn = GreaterThanFilterFn;
GreaterThanFilterFn.autoRemove = val => typeof val !== 'number';